import { useQuery, useQueryClient } from 'react-query';

import { GqlRequestOptions } from '@common/api-request';

import {
  GetMetaFeatureParams,
  META_FEATURE_QUERY_KEY,
  MetaFeatureQueryOption,
} from '../repositories/meta-feature-list';

export const useFeatureList = (params: GetMetaFeatureParams, options?: GqlRequestOptions) => {
  const queryClient = useQueryClient();
  const cache_data = queryClient.getQueryData(META_FEATURE_QUERY_KEY);
  const query_options = MetaFeatureQueryOption(params, options);
  const response = useQuery({
    ...query_options,
    enabled: !cache_data,
  });
  return {
    feature_list: response.error || !response.data ? [] : response.data,
    isLoading: response.isLoading,
  };
};
